




























































import Vue, { PropType } from 'vue';
import { Creative, PaginationData } from '@/types';
import ModalWrapper from '@/components/ModalWrapper.vue';
import Preloader from '@/components/preloader/Preloader.vue';
import { ICreative } from '@/types/campaign/creatives';
import { uniqueId } from 'lodash';
import { getCreativeInit } from '@/configs/creativeConfigs';

export default Vue.extend({
  name: 'SelectImages',
  props: {
    paginationData: {
      type: Object as PropType<PaginationData>,
    },
    imagesData: {
      type: Array as PropType<Array<Creative>>,
    },
    modal: {
      type: Boolean,
      default: false,
    },
    loadData: {
      type: Boolean,
      default: false,
    },
    sortCreatives: {
      type: String,
      required: false,
      default: '-created_ts',
    },
  },
  components: {
    ModalWrapper,
    Preloader,
  },

  mounted() {
    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.getData();
      }
    });

    this.observer.observe(this.$refs.loadMoreCreatives);
  },

  destroyed() {
    this.observer.disconnect();
  },

  watch: {
    modal() {
      this.isOpen = this.modal;
    },
  },

  computed: {
    creativeInit(): ICreative {
      return this.$store.getters['campaignCreatives/getCreativeInit'];
    },
  },

  methods: {
    getData() {
      if (
        +this.paginationData?.currentPage >= +this.paginationData?.pageCount ||
        this.requestIsExecute
      ) {
        return;
      }
      this.requestIsExecute = true;
      const result = new Promise((resolve) =>
        this.$emit(
          'loadData',
          {
            page: +this.paginationData?.currentPage + 1,
            sort: this.sortCreatives,
          },
          resolve
        )
      );
      result.then(() => (this.requestIsExecute = false));
    },
    isSelected(id: number | null) {
      if (id === null) return;
      return this.selectedCreative.indexOf(id) >= 0;
    },
    addSelected(id: number | null) {
      if (id === null) return;
      if (this.isSelected(id)) {
        this.selectedCreative = this.selectedCreative.filter(
          (item) => item != id
        );
      } else {
        this.selectedCreative.push(id);
      }
    },
    submit() {
      this.$emit(
        'submit',
        this.selectedCreative.map((id: number): ICreative => {
          const creative: Creative | undefined = this.imagesData.find(
            (item: Creative) => {
              return item.id == id;
            }
          );
          if (!creative) {
            throw new Error('Ничего не выбрано');
          }
          const creativeInit = getCreativeInit();

          creativeInit.id = uniqueId('new-');
          creativeInit.isNew = true;
          creativeInit.fileId = creative.file_id;
          creativeInit.img = creative.img;
          creativeInit.width = creative.width;
          creativeInit.height = creative.height;
          creativeInit.sourceImg = {
            img: creative.img,
            width: creative.width,
            height: creative.height,
          };

          return creativeInit;
        })
      );
      this.selectedCreative = [];
      this.$emit('input');
    },
  },

  data() {
    return {
      requestIsExecute: false,
      elCreatives: null as HTMLElement | null,
      isOpen: false,
      selectedCreative: [] as Array<number>,
      observer: null as any,
    };
  },
});
